import { render, staticRenderFns } from "./SetArrestPrepareArgsForm.vue?vue&type=template&id=3af9dc95&scoped=true&"
import script from "./SetArrestPrepareArgsForm.vue?vue&type=script&lang=ts&"
export * from "./SetArrestPrepareArgsForm.vue?vue&type=script&lang=ts&"
import style0 from "./SetArrestPrepareArgsForm.vue?vue&type=style&index=0&id=3af9dc95&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af9dc95",
  null
  
)

export default component.exports